import script from "./ReleaseAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReleaseAnnouncementModal.vue?vue&type=script&setup=true&lang=ts"

import "./ReleaseAnnouncementModal.vue?vue&type=style&index=0&id=06aae866&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06aae866"]])

export default __exports__